module.exports = __webpack_public_path__ + "img/3-5.7ca38d66.svg";